import type { RoleFragment } from "@/__generated__/graphql";
import { Queries } from "@/constants";
import { useBackendQuery } from "@/hooks/useBackendQuery";

/**
 * A business's roles - the four every business has first, then those its
 * owners added - by the node id of the business; none while there is no id.
 */
export function useEntityRoles(entityId: string | null | undefined) {
  const { data, loading } = useBackendQuery(Queries.ENTITY_ROLES_QUERY, {
    variables: { id: entityId ?? "" },
    skip: !entityId,
    fetchPolicy: "cache-and-network",
  });
  const roles: RoleFragment[] =
    data?.node?.__typename === "EntityObject" ? data.node.roles : [];
  return { roles, isLoading: loading && !data };
}
